let brandList = [
  "KAVEAH",
  "FRANCO SARTO",
  "PEANUTS",
  "AVANI GREGG",
  "THIS GIRL CAN",
  "PARIS HILTON",
  "PARIS HILTON GIRLS",
  "PARIS HILTON BABY",
  "JASON WU",
  "GIRL SQUAD",
  "LIFE IS GOOD",
  "BEAR PAW",
  "AEROPOSTALE",
  "NUBODYWEAR",
  "BANANA BOAT",
  "KIDZ BOP",
  "FIT COLLECTIVE",
  "DAISY FUENTES",
  "EXERSAUCER",
  "TOTALLY TWEEN",
  "FRENCH AFFAIR",
  "LE PETIT LULLABY",
  "GIRLS",
  "LIVERPOOL",
  "BIG DREAMS",
  "WILT",
  "BE HAPPY",
  "DANSKIN",
  "TODDLER",
  "JOE MAX JR",
  "SEALY",
  "RAE DUNN",
  "PRIVATE LABEL",
  "FRENCH TWIST",
  "K-SWISS",
  "TOTALLY ADORBS",
  "CHOOSE HAPPY",
  "SECRET STYLES",
  "TAHARI",
  "BCBG MAXAZRIA",
  "BCBG GENERATION",
  "WAIST WATCHER",
  "RBX",
  "CHARLEE RAE",
  "ICY HOT",
  "GRINCH",
  "YELLOWBERRY",
  "MORRIS & CO",
  "SHABBY CHIC",
  "ENDLESS REBEL"
]

let divisionList = [
  "LADIES",
  "LADIES PLUS SIZE",
  "MEN",
  "GIRLS",
  "BOYS",
  "INFANT GIRL",
  "INFANT BOY",
  "TODDLER GIRL",
  "TODDLER BOY",
  "BIG BOY",
  "ADULTS UNISEX",
  "HOME",
  "LITTLE BOYS",
  "KIDS UNISEX",
  "JUNIOR GIRLS",
  "NEWBORN GIRL",
  "NEWBORN BOY",
  "PETS",
  "JUNIORS MISSY",
  "NEWBORN UNISEX",
  "INFANT UNISEX",
  "TODDLER UNISEX",
  "JUNIOR BOYS",
  "MOMMY"
]

let subcategoriesList = [
  "BATH ACCESSORIES",
  "APPAREL SET",
  "ACTIVE SET",
  "LS/LL PJ SET",
  "BABY BAG",
  "PANTY",
  "BRA & PANTY SET",
  "UNDERWEAR",
  "CARRY ALL",
  "SS/LL PJ SET",
  "FACE MASKS",
  "DRAWSTRING BACKPACK",
  "CLEANING SUPPLIES",
  "BELT BAG",
  "AIR SPRAY",
  "DUFFLE",
  "HAND SANITIZER",
  "GIFTABLE SET",
  "BIBS",
  "SWEATERS",
  "HOBO",
  "JACKETS",
  "DIAPER BACK-PACK",
  "DRESSES",
  "PHONE CASE WALLET/PASSPORT",
  "WAIST CINCHER",
  "BABYDOLL",
  "BLANKET PACK",
  "SHOPPER",
  "VEST",
  "BRA",
  "HAIR ACCESSORIES",
  "BOX SET",
  "ROBE-WRAP",
  "KIMONOS",
  "BRALETTE/SOFT BRA",
  "OVERNIGHTER",
  "BRA & PANTY SET",
  "BACKPACK",
  "TRAINING PANT",
  "CHAIR",
  "CROSS-BODY",
  "REGULAR",
  "TRAVEL SET",
  "COSMETIC/SLG",
  "SCRUBS",
  "BODYSUIT",
  "SWIMSUITS",
  "CHEMISE/SLEEPSHIRT",
  "TOTE",
  "SLIPS/SKIRTS",
  "SWIM SET",
  "BURP CLOTHS",
  "SHOULDER",
  "COVERUPS",
  "LOVEYS",
  "POOL SLIDES",
  "PANT",
  "MIXED ACCESSORIES",
  "WEEKENDER",
  "SLIPPERS",
  "SHORTS",
  "SECURITY BLANKETS",
  "SNEAKERS",
  "TOP",
  "SHORTY SET",
  "SWEATSHIRT/HOODIE",
  "SWADDLE PACK",
  "FLIP FLOPS",
  "SWIM ACCESSORIES",
  "JUMPSUIT/ROMPER",
  "ONESIE",
  "SOCKS",
  "DONUT",
  "COUCH",
  "SOFA",
  "PILLOW/CLASSIC",
  "COMFORTER SET",
  "SCRATCHER",
  "CAVE",
  "PLUSH",
  "RUBBER",
  "BOWL",
  "GROOMING",
  "LEASH",
  "COLLAR",
  "THROWS",
  "TOY",
  "HATS",
  "EARMUFFS",
  "HEADBANDS",
]

let categoriesList = [
  "ACTIVEWEAR",
  "HOSIERY",
  "BASICS / INTIMATES",
  "SLEEP / LOUNGE",
  "SOCKS",
  "ACCESSORIES",
  "SHAPEWEAR",
  "APPAREL",
  "PPE",
  "HAMMOCKS",
  "FOOTWEAR",
  "BAGS",
  "ATHLEISURE",
  "OUTERWEAR",
  "LIGHT OUTERWEAR",
  "SWIMWEAR",
  "BEDS",
  "TOYS",
  "CARRIERS",
  "HUTS",
  "COLD WEATHER ACCESSORIES"
]

let sub2List = [
  'BIKINI',
  'BOXER BRIEF',
  'BOYSHORT / BOYLEG',
  'BRA W/ BIKINI',
  'BRA W/ BOYSHORT / BOYLEG',
  'BRA W/ GSTRING',
  'BRA W/ HIGHWAISTED',
  'BRA W/ HIPSTER',
  'BRA W/ THONG',
  'BRIEF',
  'CHEEKY / TANGA',
  'GSTRING',
  'HIGHWAISTED',
  'HIPSTER',
  'MOLDED CUPS',
  'PUSH-UP',
  'REMOVABLE CUPS',
  'SPORTS BRA',
  'THONG',
  'WIRE-FREE'
]

let fabricationsList = [
  "2X2 RIB",
  "3X2 RIB",
  "8X4 JERSEY RIB",
  "ACRYLIC",
  "BACK BRUSHED JERSEY",
  "BAMBOO SPANDEX JERSEY",
  "BIG LIZARD EMBOSSED LEATHER",
  "BRUSHED BACK FLEECE POLYESTER",
  "BRUSHED BACK JERSEY",
  "BRUSHED BACK STRETCH VELOUR",
  "BRUSHED HACCI",
  "BRUSHED HACCI & PLUSH",
  "BRUSHED POLY",
  "BRUSHED POLYESTER/ SPANDEX YUMMY",
  "BRUSHED RIB",
  "BRUSHED SWEATSHIRTING",
  "BRUSHED WAFFLE",
  "BUBBLE NAPPA PU",
  "BUBBLE NYLON",
  "BUTTERY NAPPY LEATHER",
  "CABLE FLEECE",
  "CABLE JERSEY",
  "CANVAS",
  "CHALLIS",
  "CHENILLE",
  "COATED CANVAS",
  "CORDUROY VELVET",
  "COTTON",
  "COTTON EYELET",
  "COTTON GAUZE",
  "COTTON MODAL JERSEY",
  "COTTON MODAL SPAN",
  "COTTON POLY",
  "COTTON/POLYESTER",
  "COTTON/POLY/LUREX",
  "COTTON POLY RAYON SPANDEX",
  "COTTON RAYON",
  "COTTON-SLUB",
  "COTTON SPANDEX",
  "COTTON/SPANDEX POPLIN",
  "COW FAJITA",
  "COW JJ NAPA",
  "COW MELANIE",
  "COW SMOOTH/SUEDE",
  "COZY TEDDY",
  "CRINKLE WOVEN",
  "CRUSHED VELOUR",
  "CRUSHED VELVET",
  "DENIM",
  "DOUBLE GAUZE",
  "DOUBLE SIDED BRUSHED POLYESTER/SPANDEX INTERLOCK",
  "DROP NEEDLE BRUSHED JERSEY",
  "DROP NEEDLE BRUSHED POLY",
  "EMBOSSED BRUSHED BACK STRETCH VELOUR",
  "EMBOSSED BRUSHED POLY",
  "EMBOSSED VELOUR",
  "EVA",
  "FABRIC/RUBBERLON",
  "FAUX FUR",
  "FAUX LEATHER",
  "FAUX SUEDE",
  "FLANNEL",
  "FLEECE",
  "FLYKNIT/PVC",
  "FRENCH TERRY",
  "GAUZE JERSEY",
  "HACCI",
  "HALF MILANO STITCH",
  "INTERLOCK",
  "JERSEY",
  "KNIT GAUZE",
  "LACE",
  "LACE COTTON/SPANDEX LINED",
  "LACE/MESH LINED",
  "LAMB SMOOTH",
  "LASER CUT",
  "LINEN/RAYON",
  "LINEN/RAYON/LYCRA",
  "LIZARD EMBOSSED LEATHER",
  "LUX FUR FLEECE",
  "MATTE SATIN JACQUARD",
  "MESH",
  "METALLIC PU/GERMAN",
  "METALLIC PU+WOVEN/GERMAN",
  "METALLIC WU CROC LEATHER",
  "MICRO",
  "MICROFLEECE",
  "MODAL",
  "MODAL SPAN",
  "MOIRE NYLON",
  "NAPPA PU",
  "NEOPRENE",
  "NEOPRENE & NAPPA PU",
  "NYLON",
  "NYLON & NAPPA PU",
  "NYLON/NEOPRENE",
  "NYLON/POLYESTER",
  "NYLON/POLYESTER/SPANDEX",
  "NYLON/SPANDEX",
  "OTTOMAN",
  "PATENT PU/GERMAN",
  "PATENT PU/TPR",
  "PATTERNED STRAW",
  "PEBBLE WOVEN",
  "PIQUE",
  "PLASTIC",
  "PLEATED LAMB PU",
  "PLISSE",
  "PLUSH",
  "PLUSH VELOUR",
  "POINTELLE KNIT",
  "POLAR FLEECE",
  "POLY",
  "POLYAMIDE/SPANDEX",
  "POLYCANVAS",
  "POLYCANVAS/PU TRIM",
  "POLY COTTON RAYON",
  "POLYESTER/RAYON",
  "POLYESTER/SPANDEX JERSEY",
  "POLYESTER/TPR",
  "POLY FLEECE",
  "POLY SATIN",
  "POLY/SPAN",
  "POLY/SPAN BRUSHED YUMMY",
  "PONGEE",
  "POPLIN",
  "PRINTED CANVAS",
  "PRINTED CANVAS/CROCHET KNIT",
  "PU",
  "PU/JUTE",
  "PU/MEMORY FOAM",
  "PU/PVC",
  "PU SUEDE/EVA",
  "PU/TPR",
  "PVC",
  "PVC/RUBBERLON",
  "RAYON",
  "RAYON/NYLON/POLY",
  "RAYON/POLYESTER/SPANDEX",
  "RAYON SPANDEX",
  "RAYON TWILL",
  "RECOVERY KNIT",
  "RECYCLED BRUSHED POLY JERSEY",
  "RECYCLED POLY COTTON",
  "RECYCLED SLUB JERSEY KNIT",
  "RIBBED HACCI",
  "RIBBED SEAMLESS & LACE TRIM",
  "RIBBED VELOUR",
  "RIB TEXTURED HACCI",
  "SATIN",
  "SATIN/GERMAN",
  "SATIN JACQUARD",
  "SATIN/TPR",
  "SATIN TWILL NYLON",
  "SEAMLESS",
  "SEERSUCKER",
  "SHERPA",
  "SHERPA LINED FLEECE",
  "SHINY SATIN",
  "SILICONE",
  "SLUB JERSEY",
  "SLUB POLY JERSEY",
  "SMOOTH LEATHER",
  "SOFT MINK FLEECE",
  "SOFT NAPPA LEATHER",
  "STRETCH VELOUR",
  "STRETCH WOVEN",
  "SUEDED MICROFLEECE",
  "SUITING",
  "SWEATER",
  "TECH NYLON",
  "TERRY CLOTH/TPR",
  "TEXTURED STRIPE SATIN",
  "TPU",
  "TRI-BLEND",
  "TWEED",
  "VARIEGATED RIB",
  "VELOUR",
  "VELOUR DROP NEEDLE RIBBED",
  "VELVET",
  "VISCOSE/LINEN",
  "WAFFLE HACCI",
  "WOVEN",
  "WOVEN JACQUARD",
  "WOVEN NYLON",
  "WU CROC EMBOSSED LEATHER",
  "WU CROCO LEATHER",
  "YUMMY",
  "PERFORMANCE JERSEY",
  "SLUB JERSEY",
  "STRETCH WOVEN",
  "CVC JERSEY",
  "PERFORMANCE RIB",
  "SCUBA",
  "FLEECE KNIT",
  "STRETCH LACE",
  "MATTE CIRE",
  "PU SHEARLING",
  "SHEARLING",
  "SHERPA LINED HACCI",
  "PLUSH VELOUR LINED FLEECE",
  "RAYON/NYLON/SPANDEX",
  "SHIMMER JERSEY",
  "METALLIC SPANDEX JERSEY",
  "RECYCLED BRUSHED POLY 2X2 RIB",
  "EMBOSSED STRETCH VELOUR",
  "LUXE STRETCH VELOUR",
  "BRUSHED POLYESTER/ SPANDEX WAFFLE",
  "RECYCLED POLYESTER/ SPANDEX",
  "TRI-BLEND SLUB JERSEY",
  "RECYCLED LUXE PLUSH",
  "METALIC ACRYLIC SPANDEX",
  "MODAL SATIN",
  "LUXE RAYON SPAN RIB",
  "HONEY COMB SWEATER",
  "SATIN LACE",
  "RECYCLED BRUSHED POLY",
  "QUILTED JERSEY",
  "BRUSHED BACK VELOUR",
  "RAYON ZEBRA JAQUARD",
  "DEMBOSSED LEO VELOUR",
  "WOVEN MATTE JACQUARD",
  "RIBBED FLEECE BACK BPJ",
  "LURE 2X2 RIB KNIT",
  "DROP NEEDLE VELOUR",
  "DROP NEEDLE HACCI",
  "SATEEN",
  "VELVET",
  "WAVY PLISSE",
  "POLY RAYON SPANDEX JERSEY",
  "GLITTER",
  "PRINTED JERSEY",
  "MICRO SUEDE/EVA",
  "MATTE STUD SATIN",
  "JACQUARD TERRY",
  "Viscose Sateen",
  "Micro Rib Rayon Span",
  "Brushed Pointelle",
  "Poly Rayon Rib",
  "Cotton Rayon Jersey",
  "Rayon Sateen",
  "Rib Pointelle",
  "Cotton Blend",
  "Luxe 2X2 Rib",
  "Debossed Terry",
  "Confetti Jersey",
  "SMOCKED SMOOTH SATIN",
  "MINI RIB",
  "TEXTURED GAUZE 2X2 RIB",
  "TEXTURED GAUZE",
  "RUFFLED RAYON",
  "DROP NEEDLE PEACHED RIB",
  "FLOWY VISCOSE SATEEN",
  "WOVEN MATTE",
  "RAYON WOVEN JAQUARD",
  "VELOUR",
  "SOFT RIB POINTELLE",
  "SPACE DYE CONFETTI JERSEY",
  "RAYON CHALLIS",
  "RAYON CHILL",
  "KNIT JERSEY GAUZE",
  "BRUSHED POLY JERSEY",
  "RECYCLE POLY SLUB JERSEY",
  "RAYON JERSEY",
  "RECYCLED BRUSHED POLY JERSEY",
  "POLY RAYON SPANDEX",
  "BRUSHED POLY SPAMDEX",
  "BRUSHED POLY JERSEY SPANDEX",
  "KINT GAUZE POLY SPANDEX",
  "Rayon Crinkle Gauze",
  "POLY /SPAN PLISSE",
  "POLY /SPAN YUMMY",
  "KINT GAUZE",
  "POLY TWILL",
  "OMBRE PLISSE",
  "BRUSH YUMMY JERSEY",
  "WAFFLE KNIT",
  "knit pique",
  "KNIT CREPE",
  "RIB KNIT",
  "CRINKLE KNIT",
  "SOFT MESH",
  "PRINTED CHAMBRAY",
  "COTTON VOILE",
  "SOFT TERRY",
  "Printed Pointelle Rib",
  "DROP NEEDLE PEACHED RIB",
  "SLINKY JERSEY",
  "POLY COTTON",
  "SLUB CREPE",
  "WOVEN TEXTURED DOBBY",
  "BRUSH POLY JERSEY/ 2X2 RIB",
  "RIPSTOP",
  "PEACHED TWILL",
  "SEARSUCKER",
  "textured woven double gauze",
  "SCHIFFLI DENIM",
  "3X2 BRUSHED RIB",
  "TERRYCLOTH/EVA",
  "GLITTER/PU",
  "RAYON SPANDEX JERSEY",
  "RAYON CHALLIS WOVEN",
  "DOTTY JACQUARD",
  "POLY COTTON EYELET",
  "STRETCH SATEEN",
  "EMBOSSED BPJ/2X2 RIB",
  "BPJ/EMBOSSED BPJ",
  "TERRY",
  "BRUSHED POLY 2X2 RIB",
  "DOUBLE KNIT FLEECE",
  "POLY RAYON",
  "BRUSHED POINTELLE AND RECYCLED BRUSHED POLY JERSEY",
  "BRUSHED POINTELLE AND COTTON RAYON JERSEY",
  "COTTON RAYON JERSEY AND SEERSUCKER",
  "RECYCLED BRUSHED POLY JERSEY AND 2X2 LUXE RIB JERSEY",
  "2X2 LUXE RIB JERSEY AND RECYCLED BRUSHED POLY JERSEY",
  "RECYCLED BRUSHED POLY AND 2X2 LUXE RIB JERSEY AND KNIT GAUZE JERSEY",
  "WOVEN POLY",
  "RAYON CHALLIS AND 2X2 RIB",
  "COTTON POLY",
  "POLY SPAN VARIGATED RIB",
  "LUXE DROP NEEDLE RIB",
  "MICRO RIB / WRINKLED WOVEN",
  "WRINKLED WOVEN",
  "BRUSHED POLY AND 2X2 RIB",
  "KNIT GAUZE JERSEY",
  "COTTON POLY EYELET",
  "COTTON MODAL SLUB",
  "POLY COTTON EYELET AND BRUSHED POLY JERSEY",
  "BRUSHED POLY DROP NEEDLE JERSEY",
  "LUREX PINSTRIPE",
  "RECYCLED SLUB",
  "TRI BLEND SLUB JERSEY / BRUSHED POLY JERSEY",
  "RECYCLED BRUSHED POLY JERSEY / POINTELLE WAFFLE",
  "POINTELLE WAFFLE",
  "TEXTURED WOVEN",
  "POLY WAFFLE",
  "8x3 RIB",
  "POLY WOVEN",
  "Flocking",
  "SCUBA MICRO",
  "COTTON POLY AND BRUSHED POLY JERSEY",
  "CHALLIS",
  "DROP NEEDLE RIB",
  "POLY PLISSE",
  "woven twill",
  "WOVEN COTTON / RAYON",
  "VARIEGATED RIB KNIT",
  "RECYCLED BRUSHED WAFFLE",
  "WIDE RIB",
  "PLUSH",
  "EMBOSSED FRENCH TERRY",
  "POLY Baby French Terry",
  "Towel Terry",
  "Cotton Flannel",
  "Poly Flannel",
  "KNIT EYELET",
  "RAYON/COTTON CROSSHATCH",
  "COTTON/POLY FLEECE",
  "POLY/RAYON/SPAN FLEECE",
  "CVC POPLIN",
  "COTTON POPLIN",
  "COTTON/POLY POPLIN",
  "CHAMBRAY",
  "POLY SPACE DYE FLEECE",
  "COTTON DOUBLE GAUZE",
  "190T TAFFETA",
  "210T TAFFETA",
  "POLY/RAYON FLEECE",
  "COTTON/POLY JERSEY",
  "COTTON/POLY/SPAN RIB",
  "CVC FLANNEL",
  "POLY/SPAN RIB VELOUR",
  "CRINKLE RAYON GAUZE",
  "POLY/SPAN TEXTURED KNIT & RIB",
  "POLY/SPAN BRUSHED RIB & SHERPA",
  "CVC JERSEY W/ POLY SHERPA & FLEECE",
  "POLY WAFFLE FLANNEL FLEECE",
  "POLYWOVEN & POLY PLUSH",
  "CVC JERSEY & KNIT DENIM",
  "CVC JERSEY & COTTON CRINKLE GAUZE",
  "CVC FLANNEL & FAUX FUR",
  "ACRYLIC BLEND SWEATER & CVC JERSEY & CTN/SPAN RIB",
  "POLY PONGEE CVC JERSEY & CTN/SPN RIB",
  "CVC FRENCH TERRY & JERSEY AND POLY TULLE",
  "CVC JERSEY & TOWEL TERRY",
  "RAYON CHALLIS TWILL & KNIT DENIM",
  "CVC RIB & JERSEY AND CTN CHAMBRAY",
  "CVC RIB & JERSEY & OXFORD",
  "CTN/POLY SLUB JERSEY",
  "CTN/POLY TOWEL TERRY",
  "LACE & PEACHED CANVAS",
  "CVC FRENCH TERRY & RIB",
  "CVC FLEECE & JERSEY",
  "CVC FRENCH TERRY & JERSEY",
  "TPU",
  "COTTON/SPAN 2X2 RIB",
  "CVC JERSEY & FOIL MESH",
  "CVC FLEECE & POLY/SPN FUR-LINED FLEECE",
  "POLY FLEECE & FAUX LEATHER",
  "SWEATER & RAYON CHALLIS TWILL",
  "CVC FLEECE & COZY THERMAL",
  "CTTN FRENCH TERRY & POLY MESH",
  "CVC FRENCH TERRY & DENIM",
  "CVC SLUB JERSEY + POLY MESH",
  "CVC FLEECE & BIRDSEYE JACQUARD",
  "CTN WOVEN PLAID & CTN/SPAN JERSEY",
  "CTN WOVEN PLAID & FAUX LEATHER",
  "POLY FLANNEL CVC JERSEY & CTN/POLY/SPN KNIT DENIM",
  "CVC JERSEY + POLY/RAYON CORDUROY",
  "RAYON/SPAN RIB + DBL SIDED BRUSHED TWILL",
  "POLY SHERPA & POLY/NYLON PEACHED CANVAS",
  "COTTON/RAYON FRENCH TERRY",
  "CTN/RAYON FRENCH TERRY & CVC JERSEY",
  "SWEATER + DBL SIDED BRUSHED TWILL",
  "CVC FLEECE & DBL SIDED BRUSHED TWILL",
  "CTN/RAYON FRENCH TERRY & CVC RIB",
  "SWEATER & CVC JERSEY & FLEECE",
  "CVC SLUB JERSEY & BABY FRENCH TERRY",
  "CVC SLUB JERSEY & CRINKLE RAYON GAUZE",
  "BURNOUT MESH",
  "TAFFETA & CVC JERSEY & P/S RIB",
  "CVC FLEECE",
  "UPF50+ P/S SWIM KNIT",
  "UPF50+ P/S SWIM KNIT & POWERMESH",
  "UPF50+ P/S SWIM KNIT & CROCHET LACE",
  "RAYON/SPAN RIB + POLY/RAYON CORDUROY",
  "POLY WOVEN TWILL & FAUX FUR",
  "QUILTED POLY/SPAN KNIT & CVC JERSEY",
  "UPF50+ P/S SWIM KNIT & CVC SLUB GAUZE",
  "CVC FLEECE & POLY/SPN JERSEY & POLY WOVEN TECH",
  "CTTN KNIT PIQUE & WOVEN TECH",
  "CVC RIB POLY POWERMESH & YUMMY JERSEY",
  "COTTON-BLEND RIB & POLY/MODAL/SPAN SCUBA",
  "CVC/SPAN SLUB JERSEY & BABY FRENCH TERRY",
  "CTTN TEXTURED KNIT & CVC DENIM",
  "UPF50+ POLY/NYLON/SPAN STRIPE KNIT",
  "UPF50+ P/S TEXTURED SWIM KNIT",
  "PEACHED SPACE DYE",
  "PERFORMANCE POLY",
  "PERFROMANCE SPACE DYE",
  "ENGINEERED MESH",
  "UPF50+ P/S TEXTURED SWIM KNIT & CROCHET KNIT",
  "UPF50+ P/S SWIM KNIT & TEXTURED SWIM KNIT",
  "P/S FRENCH TERRY",
  "POLY FLEECE & P/S JERSEY & WOVEN TECH",
  "CTTN JERSEY & CVC DENIM",
  "P/S JERSEY INTERLOCK",
  "HACCI RIB",
  "CVC JERSEY & WOVEN P/S STRETCH",
  "CVC JERSEY & CTTN POPLIN",
  "CVC/SPN RIB & POLY BABY FRENCH TERRY",
  "CVC/SPN RIB & CTTN DOUBLE GAUZE",
  "CVC JERSEY & CTTN DOUBLE GAUZE",
  "RAYON/POLY/NYLON SWEATER KNIT",
  "CVC JERSEY & VISCOSE TWILL",
  "CVC JERSEY & CTTN CHAMBRAY",
  "POLY FAKE MEMORY & FAUX FUR",
  "CTN/SPAN TWILL & POLY SHERPA",
  "CTN-BLEND RIB & CRINKLE RAYON GAUZE",
  "SWEATER & RAYON TWILL",
  "CTN/SPAN FLEECE & POLY/SPAN INTERLOCK",
  "POLY/RAYON FLEECE & CVC RIB",
  "COTTON RIB & SEERSUCKER",
  "CTN/RAYON FRENCH TERRY & CTTN/SPAN RIB",
  "CVC FLEECE & RIB",
  "CVC BABY FRENCH TERRY",
  "CVC/SPN INTERLOCK JERSEY",
  "CVC/SPAN JERSEY",
  "COTTON SWISS DOT",
  "SWEATER & CVC RIB",
  "POLY/CTTN/SPN BOUCLE & CVC JERSEY",
  "CTTN SLUB JERSEY & POLY CROSSHATCH",
  "CABLE KNIT",
  "PRINTED PLUSH VELOUR",
  "TEDDY FLEECE",
  "PEACHED POLY",
  "BRUSHED POLY/SPAN YUMMY POINTELLE",
  "POLY/CTN/LUREX CRINKLE GAUZE",
  "TAFFETA & CVC JERSEY & POLY FLEECE",
  "ANTI PILLING FLEECE",
  "POLY/SPAN",
  "RIPPLE KNIT",
  "TECH FLEECE",
  "JACQUARDED EMBOSSED FLANEL FLEECE",
  "CVC SEERSUCKER",
  "CVC JERSEY & CTTN OXFORD",
  "CVC JERSEY & POLY MICROFLEECE & FLEECE",
  "COTTON OXFORD",
  "CVC JERSEY & OXFORD",
  "CVC JERSEY & P/S BABY FRENCH TERRY",
  "CVC JERSEY & SEERSUCKER",
  "LUXE PLUSH",
  "BRUSHED POLY FLANNEL",
  "CVC INTERLOCK",
  "BRUSHED YUMMY",
  "ORGANZA",
  "2X2 LUXE RIB JERSEY",
  "3X2 RIB BRUSHED POLY JERSEY",
  "COTTON RAYON JERSEY",
  "BRUSHED POINTELLE JERSEY",
  "SOFT BRUSHED BACK JERSEY, 2X2 RIB",
  "COZY BRUSHED JERSEY",
  "BRUSHED RIBBED KNIT",
  "WIDE POLY RIB JERSEY",
  "FLAT & RIBBED VELOUR",
  "BRUSHED POLY / 2X2 RIB JERSEY",
  "WIDE RIBBED VELOUR",
  "COZY BRUSHED BACK",
  "ULTRA SOFT BRUSHED POINTELLE",
  "LINEAR STRETCH VELOUR",
  "BRUSHED WIDE RIB",
  "BRUSHED BACK JERSEY",
  "TRI BLEND / BRUSHED WAFFLE",
  "SINGLE BRUSHED WAFFLE",
  "ULTRA BRUSHED POINTELLE",
  "WIDE RIB KNIT",
  "SLUB FANCY RIB",
  "BRUSHED BACK FLEECE",
  "ULTRA BRUSHED WAFFLE",
  "MODAL POLY SPAN",
  "EMBOSSED JERSEY",
  "CRINKLE VELVET",
  "DROP NEEDLE SOFT RIB",
  "4X2 RIB BPJ",
  "ULTRA FLEECE VARIEGATED RIB",
  "RAYON SATEEN",
  "ULTRA SOFT 2X2 RIB",
  "FLEECE BACK BRUSHED POLY",
  "WOVEN COTTON / RAYON",
  "2X2 RIB JERSEY",
  "FLAT AND RIBBED",
  "POLY SPAN VARIEGATED RIB",
  "UPF50+ P/S SWIM KNIT & SWIM TULLE",
  "WIDE POLY RIB",
  "FLAT AND RIBBED VELOUR",
  "POLY SPAN VARIGATED RIB",
  "POLY MESH & COTTON SHEETING",
  "CVC PIQUE & JERSEY",
  "CVC JERSEY W/ POLY SHERPA & P/S RIB",
  "BRUSHED POLY/ 2X2 RIB",
  "YUMMY RIB",
  "RAYON SPAN DROP NEEDLE",
  "300T POLY TAFFETA",
  "CORAL FLEECE",
  "P/S BABY FRENCH TERRY",
  "COZY BRUSHED JERSEY",
  "4X2 RIB BPJ",
  "ULTRA SOFT 2X2 RIB",
  "BRUSHED POLY JERSEY / ULTRA BRUSHED WAFFLE",
  "CTN/RYN FRENCH TERRY & CVC JERSEY",
  "SUEDE BACK STRETCH PU",
  "Bonded Chenille & Sherpa Lined",
  "Ribbed Flannel Fleece",
  "LUXE 2X2 JERSEY RIB / BRUSHED POLY",
  "POLY FLEECE",
  "YUMMY DROP NEEDLE",
  "PLUSH / SHERPA",
  "BONDED PLUSH / SHERPA",
  "PLUSH-180 GSM",
  "SHERPA-180 GMS",
  "STRETCH VELOUR",
  "BRUSHED POINTELLE JERSEY",
  "Jersey",
  "Felt",
  "100% LEATHER",
  "CVC FLEECE & INTERLOCK",
  "SOFT TOUCH FLEECE",
  "LINEN-RAYON BLEND",
  "CVC JERSEY & LINEN/RAYON",
  "SPACE DYE",
  "RIB / RECYCLED BRUSHED POLY",
  "SOFT JERSEY GAUZE",
  "ANTI PILLING FLEECE",
  "DOT TERRY",
  "SEAMLESS RIB",
  "CVC RIB JERSEY & CTTN DOUBLE GAUZE",
  "ATHLEISURE RIB",
  "Walffle/Polyester",
  "Woolen/Polyester",
  "COTTON POPLIN W/ LUREX",
  "CVC SLUB JERSEY CTTN GAUZE & CVC DENIM",
  "CVC SLUB JERSEY & CTTN GAUZE",
  "CVC SLUB JERSEY CTTN GAUZE & CVC TWILL",
  "Hersey/Polyester",
  "Cotton poplin & denim",
  "CVC denim & poplin",
  "CVC SLUB JERSEY & TWILL",
  "CVC SLUB JERSEY & DENIM",
  "Popcorn Knit",
  "Knit Jacquard",
  "Brushed CVC cotton",
  "4X2 SOFT RIB",
  "viscose/spandex",
  "4x2 RIB",
  "SOFT DROP NEEDLE",
  "CVC",
  "FLORAL TEXTURE KNIT JACQUARD",
  "DREAM JERSEY",
  "SLUB / BRUSHED POLY JERSEY",
  "SOFT 2X2 RIB",
  "TEXTURED STRIPE KNIT",
  "SOFT TOUCH HEATHER JERSEY",
  "Stretch Eyelet",
  "ATHLEISURE SLUB",
  "TWIST RIB",
  "HW PEACHED SPACE DYE",
  "STRETCH GINGHAM",
  "ATHLEISURE RIB",
  "TEXTURED KNIT",
  "POLY RAYON NYLON SILVER LUREX HACCI",
  "Peached Performance Interlock",
  "Unbrushed 1x1 rib",
  "Texture Lattice",
  "SOFT QUILTING",
  "RAYON SWEATER RIB",
  "Recycled Brushed Poly Jersey / 2x2 Rib",
  "Tri Blend Slub / Recycled Brushed Poly Jersey",
  "Wide rib drop needle",
  "Modal Sweater Rib/ Recycled Brushed Poly Jersey",
  "POLY SPANDEX",
  "Texture Back Jersey",
  "Shadow Stripe Texture",
  "Viscose Cotton Spandex",
  "Rayon Cotton Spandex",
  "Bamboo Seamless",
  "CVC/SPAN JERSEY + CVC FRENCH TERRY",
  "RAYON NOVELTY CLIP JACQUARD",
  "ULTRA BRUSHED SLINKY",
  "BRUSHED CABLE",
  "SEAMLESS TEXTURE",
  "EMBOSSED PLUSH",
  "BRUSHED IRREGULAR RIB",
  "COTTON POLY SPAN",
  "QUILTED STRIPE",
  "BRUSHED DREAEM STITCH",
  "CVC/SPAN JERSEY + CVC FLEECE",
  "CASHMERE BLEND",
  "WOOL BLEND",
  "Cloud Knit",
  "Herringbone Knit",
  "VELVET PLUSH",
  "Engineered Lace",
  "Brushed Mesh Stripe",
  "Fleecelined Interlock",
  "PONY HAIR",
  "Lyocell Blend Jersey",
  "Brushed Dot Jacquard",
  "Brushed Mini Rib Jacquard",
  "RHINESTONE METAL CHAINMAIL",
  "Soft Knit",
  "Stretch Poly Velour",
  "Poly Plush",
  "Stretch Cotton Jersey",
  "MICROSUEDE",
  "Hybrid Knit",
  "BRUSHED JACQUARD",
  "STRIPE JACQUARD",
  "RIB JACQUARD",
  "JACQUARD",
  "RIB DREAM JERSEY",
  "BURN OUT JERSEY",
  "100% polyester faux fur",
  "Cozy Rib",
  "Modal Span Jersey",
  "Clip Dot",
  "Cotton Clip Dot",
  "Slub Jersey Knit",
  "Supima Jersey",
  "Vintage Jersey"
].map(x => x.toUpperCase())

let colorList = [
  "BLACK",
  "GRAY",
  "HEATHERED GRAY",
  "WHITE",
  "IVORY",
  "TIE DYE",
  "IVORY",
  "OFF-WHITE",
  "GOLD",
  "BROWN",
  "BEIGE",
  "GREEN",
  "BLUE",
  "PURPLE",
  "RED",
  "PINK",
  "YELLOW",
  "ORANGE",
  "CORAL",
  "WHITE",
  "PINK",
  "MULTI"
]

let packsList = [
  "SINGLE",
  "2 PACK",
  "3 PACK",
  "4 PACK",
  "5 PACK",
  "6 PACK",
  "7 PACK",
  "8 PACK",
  "9 PACK",
  "10 PACK",
  "11 PACK",
  "12 PACK",
  "13 PACK",
  "14 PACK",
  "SET",
  "PACKAGED",
  "20 PACK"
]

let repList = [
  "NO REP",
  "UNDEFINED",
  "admin2@ihlgroup.com",
  "alex_sales@ihlgroup.com",
  "amanda.g_sales@ihlgroup.com",
  "amanda.rosen@ihlgroup.com",
  "carly.goldfarb_sales@ihlgroup.com",
  "cat_sales@ihlgroup.com",
  "daniela_sales@ihlgroup.com",
  "eveleen_sales@ihlgroup.com",
  "ishalom@ihlgroup.com",
  "izak@ihlgroup.com",
  "jillian.v@ihlgroup.com",
  "libby.f@ihlgroup.com",
  "michelle@ihlgroup.com",
  "moro@ihlgroup.com",
  "nicole@ihlgroup.com",
  "robin_sales@ihlgroup.com",
  "samantha.cooper@ihlgroup.com",
  "sami@ihlgroup.com",
  "tessa.addeo_sales@ihlgroup.com",
  "allison.c_sales@ihlgroup.com",
  "allison.c@ihlgroup.com"
]

let accountList = [
  "10 BELOW LLC",
 "10 SPOT",
 "1111 MEDIA / LONDON AUDIO, INC",
 "A TO Z FASHIONS",
 "A&M (2015) LLC.",
 "A&M (2015) LLC.:MANDEE",
 "ABC",
 "AERO MEXICO",
 "ALKO DISTRIBUTORS INC.",
 "ALL WRAPPED UP",
 "ALPHAGILITY",
 "AMAZON.COM LLC",
 "AMERICA'S KIDS:AMERICAS KIDS #103",
 "AMERICA'S KIDS:AMERICAS KIDS #105",
 "AMERICA'S KIDS:AMERICAS KIDS #106",
 "AMERICA'S KIDS:AMERICAS KIDS #110",
 "AMERICA'S KIDS:AMERICAS KIDS #119",
 "AMERICA'S KIDS:AMERICAS KIDS #122",
 "AMERIMARK DIRECT LLC",
 "ARMY AND NAVY",
 "ASHLEY STEWART:ASHLEY STEWART",
 "ASHLEY STEWART:ASHLEY STEWART E-COMMERCE",
 "B.K.V. INC.",
 "B2 OUTLET STORES",
 "BANANA BAY:BODY BEAUTIFUL",
 "BARGAIN HUNT",
 "BEALL'S",
 "BEALL'S OUTLET",
 "BEALL'S:BEALLS DEPARTMENT - SLEEPWEAR",
 "BEARPAW OUTLET STORE",
 "BELA INTIMA/ INVERSIONES MAG",
 "BELLEVILLE BUSINESS",
 "BIG BOX OUTLET",
 "BIG LOTS",
 "BJ'S",
 "BLUE WATER TRADING",
 "BRANDS FOR LESS FZCO",
 "BURLINGTON",
 "BURLINGTON - BRAS - CAMILLE",
 "BURLINGTON INNA",
 "BURLINGTON:BURLINGTON -SHAPE",
 "BURLINGTON:BURLINGTON ACCESSORIES",
 "BURLINGTON:BURLINGTON ACTIVEWEAR",
 "BURLINGTON:BURLINGTON JUNIOR",
 "BURLINGTON:BURLINGTON JUNIOR APPAREL",
 "BURLINGTON:BURLINGTON KIDS",
 "BURLINGTON:BURLINGTON MEREDITH",
 "BURLINGTON:BURLINGTON SLEEP",
 "BURLINGTON:BURLINGTON SPORTSWEAR - MISSY",
 "BURLINGTON:BURLINGTON-FOOTWEAR",
 "CATCHOFTHEDAY.COM.AU PTY LTD",
 "CATCO",
 "CATO",
 "CENTURY 21 STORES",
 "CHARLE'S INT'L LLC",
 "CITI TRENDS",
 "CITI TRENDS:CITI TRENDS - DRESS",
 "CITI TRENDS:CITI TRENDS - KDS",
 "CITI TRENDS:CITI TRENDS - LADIES APPAREL",
 "CITI TRENDS:CITI TRENDS -INTIMATE",
 "CLOSEOUT CONNECTION",
 "COLORS",
 "CONCEPT ONE",
 "COOKIES",
 "COPPEL",
 "COPPEL ECOM",
 "COSTCO CANADA",
 "COSTCO JAPAN",
 "COSTCO MEXICO",
 "COSTCO TAIWAN",
 "COSTCO US ECOM",
 "CRACKER BARREL",
 "CRADLES TO CRAYONS",
 "CUSTOMER SAMPLES",
 "CVS",
 "D SPROUT INC",
 "DAC JEWELRY",
 "DD'S",
 "DD'S - ALLIE",
 "DD'S - NAOMI",
 "DD'S - PANTIES",
 "DD'S - SAMANTHA",
 "DD'S:DD JUNIOR APPAREL",
 "DD'S:DD JUNIOR APPAREL 2",
 "DD'S:DD SLIPPERS",
 "DD'S:DD'S - BEARPAW OUTERWEAR",
 "DD'S:DD'S - BEARPAW SPORTSWEAR",
 "DD'S:DD'S - PARIS HILTON OUTERWEAR",
 "DD'S:DDS - AMY",
 "DD'S:DDS - MARILYN",
 "DD'S:DDS -ACTIVE - M GRANIERI",
 "DD'S:DDS -JUNIOR - G DEORDIO",
 "DD'S:DDS -MENS",
 "DD'S:DDS COSMETIC BAGS",
 "DD'S:DDS DISCOUNTS - JUNIOR PLUS",
 "DE JANIERO",
 "DILLARD'S",
 "DISCOVERY",
 "DOLLAR GENERAL - DOLGENCORP, LLC",
 "DOYAN S.A",
 "DUPLICAT",
 "EASY PICKINS",
 "ELAND",
 "EMPRESA CURBELO DURAN INC",
 "EXOTIC:EXOTIC SECRETS LINGERIE CORP - ELIZABETH",
 "EXOTIC:EXOTIC SECRETS LINGERIE CORP - PASSAIC",
 "FACTORY CONNECTION",
 "FAMILY DOLLAR",
 "FASHION BRANDS GROUP",
 "FASHION NOVA",
 "FIELDS CANADA",
 "FIVE BELOW MERCHANDISING, INC.",
 "FOREVER 21",
 "FORMAN MILLS INC",
 "FOX'S",
 "FREDERICKS OF HOLLYWOOD",
 "FRENCH AFFAIR.CO",
 "G.T WHOLESALE LTD",
 "GABRIEL BROS.",
 "GAZOZ INC",
 "GHOST",
 "GLOBAL DTC LLC",
 "GOLDEN TOUCH OF NYC",
 "GOODS 4 U",
 "GRAND STORES CORPORATION",
 "GUSSINI:GUSSINI #15",
 "H & D MOVIE SALES INC",
 "HALF PRICE - PRICE POINT",
 "HAMRICKS",
 "HEPBURN LLC",
 "HOMEGOODS",
 "HUCK FINN CLOTHES, INC.",
 "ICY HOT",
 "IHL ECOMMERCE",
 "IHL PIXIOR",
 "IMPEXOL S DE RL DE CV",
 "IMPRESSONS , LLC",
 "INDUSTRIALES MARAVEDIS",
 "INPACTO",
 "INVERSIONES POCAHONTAS C/O LEGEND EXPRESS",
 "J PICA & CO. INC.",
 "J.V.M. VARIETY",
 "JACQUELINE INTIMATES",
 "JEANS WAREHOUSE, INC",
 "JENNYS",
 "KADIMA S.A.",
 "KARMIN INDUSTRIES",
 "KRESS STORES OF PUERTO RICO,INC.",
 "LA CUSTOMERS:BEST LINE INC",
 "LA CUSTOMERS:CONSTANT TRADING",
 "LA CUSTOMERS:SMILE LINGERIE",
 "LA CUSTOMERS:SWEET UNDYS",
 "LADY LOVE",
 "LIBERATION AND HEALING PENTECOSTAL",
 "LIVERPOOL MX / ZURI",
 "LOSHA",
 "LOST INV",
 "LOT LESS",
 "LUCKY ROSE BOUTIQUE",
 "MACY'S / BLOOMINGDALE'S:BLOOMINGDALE'S OUTLET",
 "MACY'S / BLOOMINGDALE'S:MACY'S BACKSTAGE",
 "MACY'S / BLOOMINGDALE'S:MACY'S DEPT",
 "MACY'S / BLOOMINGDALE'S:MACY'S DROPSHIP",
 "MARIA ELENA",
 "MAVICCI CORP",
 "MEXICO SALIM",
 "MOST FAMOUS",
 "NATIONAL STORES INC",
 "NATORI COMPANY",
 "NEFF PHARM",
 "NEIMAN MARCUS GROUP",
 "NEX - NAVY EXCHANGE SERVICE",
 "NORDSTROM RACK",
 "NYC IDOL APPAREL",
 "OLD TIME POTTERY",
 "OURI ALKADA",
 "OURI ALKADA (ASOF)",
 "PAC SUN",
 "PARIS EVENT",
 "PIXIOR",
 "PRICESMART, INC",
 "QT PIE",
 "QVC",
 "QVC DROPSHIP",
 "RAE DUNN ECOMM",
 "RED APPLE STORES",
 "REFLEX SALES GROUP",
 "RENT THE RUNWAY",
 "RENY, INC.",
 "ROMANTIX",
 "ROSS",
 "ROSS KIDS",
 "ROSS:ROSS - LINDA (SHAPE)",
 "ROSS:ROSS ACTIVEWEAR",
 "ROSS:ROSS BABYDOLLS",
 "ROSS:ROSS CARLY COLUCCI",
 "ROSS:ROSS GRAPHICS/FLEECE",
 "ROSS:ROSS JAIMIE",
 "ROSS:ROSS SHAPEWEAR-LINDA",
 "ROSS:ROSS SLEEP",
 "ROSS:ROSS TAHARI",
 "ROSS:ROSS-JR INTIMATES -JULLIAN",
 "ROSS:ROSS-JR TOPS -JILLAIN",
 "ROSS:ROSS-LADIES PLUS APPAREL",
 "ROSS:ROSS-SLIPPERS",
 "RUE LA LA, INC.",
 "RUE21",
 "S & A STORES",
 "SAKS OFF 5TH DROPSHIP",
 "SAKS OFF5TH.COM",
 "SAM'S CLUB SLEEPWEAR",
 "SAPMAN SPORTSWEAR",
 "SAVE SMART STORES",
 "SEARS HOLDING CORPORATION",
 "SEMIR",
 "SEXXY LENCERIA",
 "SHALOM",
 "SHES INTERNATIONAL BOUTIQUE",
 "SHOPPERS",
 "SIERRA TRADING POST",
 "SMART FASHION",
 "STAGE STORES INC.",
 "STYLES FOR LESS",
 "SUBURBIA - MX / ZURI",
 "TAHARI ECOMM",
 "TELCO",
 "TICK TOCK:01 DISCO 1 BOUTIQUE INC.",
 "TILLYS",
 "TILLYS ECOMM",
 "TJX AUSTRALIA",
 "TJX-EU",
 "TJX/MARSHALLS",
 "TJX/MARSHALLS ECOMM",
 "TOYS FOR SIMCHA",
 "TREASURE ISLAND",
 "UNITED FASHION OF TEXAS,LTD",
 "UNIVERSAL TRY SA NDE CV",
 "VARIETY WHOLESALERS INC.",
 "VARIETY:BIG LOTS / VARIETY WHOLESALE",
 "VARIETY:VARIETY WHOLESALERS INC.",
 "VERSONA",
 "VON MAUR",
 "W & W WHOLESALE INC",
 "WAL-MART STORES, INC.:WALMART USA (STORE)",
 "WAL-MART STORES, INC.:WALMART USA-ECOMM",
 "WALMART CANADA",
 "WALMART DROPSHIP",
 "WILCOTEX S.A.",
 "WINDSOR",
 "WINNERS MERCHANTS INC",
 "WORLD REP LLC",
 "Y & H CREATIONS",
 "YM INC",
 "ZULILY"
]

let singleSizesList = [
  "PREPACK",
  "NONE",
  "0-9 MO",
  "12-24 MO",
  "XXS",
  "XS",
  "XS(2/3)",
  "S",
  "S(4/6)",
  "S/M",
  "M",
  "M(7/8)",
  "L",
  "L(10/12)",
  "L/XL",
  "XL",
  "1XL",
  "2XL",
  "1X",
  "2X",
  "3X",
  "4X",
  "5X",
  "2X/3X",
  "XXL",
  "XXXL",
  "30A",
  "32A",
  "34A",
  "34B",
  "34C",
  "36B",
  "36C",
  "36D",
  "36DD",
  "38C",
  "38D",
  "38DD",
  "40C",
  "40D",
  "40DD",
  "42C",
  "42D",
  "2T",
  "3T",
  "4T",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "6-9 mo",
  "12 mo",
  "18 mo",
  "0M",
  "3M",
  "6M",
  "9M",
  "12M",
  "18M",
  "A",
  "B",
  "C",
  "D",
  "ONE SIZE",
  "JUNIOR ONE SIZE",
  "34B/S",
  "34C/M",
  "36B/M",
  "4/5",
  "5/6",
  "6/6x",
  "7/8",
  "10/12",
  "14/16",
  "15",
  "16",
  "17",
  "18",
  "18/20",
  "19",
  "20",
  "21",
  "22",
  "22/24",
  "23",
  "24",
  "25",
  "26",
  "26/28",
  "27",
  "28",
  "29",
  "30",
  "30/32",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "36C/L",
  "36DD/1X",
  "37",
  "38",
  "38C/XL",
  "38D/1X",
  "38DD/2X",
  "39",
  "40",
  "40D/2X",
  "40DD/3X",
  "41",
  "42",
  "42D/3X",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "FULL/QUEEN",
  "KING",
  "13 x 13",
  "16 x 28",
  "30 x 54",
  "30 x 56",
  "50 x 70",
  "50 x 60",
  "60 x 70",
  "Twin",
  "Full",
  "Queen",
  "Cal King",
  "20 x 20",
  "18 x 18",
  "20 x 7",
  "12 x 12",
  "20 x 30",
  "28 x 55",
  "20 x 36",
  "18 x 26",
]

let sizesList = [
  "S-M-L-XL: 1-2-2-1",
  "0,2,4,6,8,10: 1-1-1-1-1-1",
  "0-3mo,3-6mo,6-9mo: 1-3-2",
  "0/3M-3/6M-6/9M: 1-3-2",
  "0/3M-3/6M-6/9M: 2-2-2",
  "1-3-5-7-9-11-13-15: 1-1-2-2-2-2-1-1",
  "10/12-14/16-18/20: 2-3-3",
  "10/12-14/16-18/20: 3-4-4",
  "10/12-14/16-18/20: 4-5-6",
  "12M-18M-24M-2T-3T-4T: 1-1-1-1-1-1",
  "12M-18M-24M: 1-2-1",
  "12M-18M-24M: 2-2-2",
  "12M-18M-24M: 4-4-4",
  "12M-18M: 3-3",
  "18M-2T-3T-4T: 1-2-2-1",
  "1X-2X-3X: 1-1-1",
  "1X-2X-3X: 1-2-1",
  "1X-2X-3X: 2-1-1",
  "1X-2X-3X: 2-2-1",
  "1X-2X-3X: 2-2-2",
  "1X-2X-3X: 2-3-1",
  "1X-2X-3X: 3-2-1",
  "1X-2X: 2-1",
  "1X-2X: 2-2",
  "1X-2X: 3-2",
  "1X/2X-2X/3X: 3-3",
  "2,4,6,8,10,12: 1-1-1-1-1-1",
  "2,4,6,8,10,12: 1-2-2-1-1-1",
  "2,4,6,8,10: 1-1-2-1-1",
  "2-4-6-8-10-12: 1-1-2-2-1-1",
  "28A-30A-32A-34A: 1-1-2-2",
  "2T-3T-4T-5-6-7: 1-1-2-2-1-1",
  "2T-3T-4T-5T: 1-2-2-1",
  "2T-3T-4T-5T: 2-2-2-1",
  "2T-3T-4T: 1-1-1",
  "2T-3T-4T: 1-2-1",
  "2T-3T-4T: 2-2-2",
  "2T-3T-4T: 2-3-3",
  "2T-3T-4T: 3-3-2",
  "2T-3T-4T: 3-3-3",
  "2T-3T-4T: 8-8-8",
  "2T-3T: 1-1",
  "2T-3T: 3-3",
  "2T/3T-4T: 3-3",
  "3-6mo,6-9mo,12mo,18mo: 1-2-2-1",
  "3-6mo,6-9mo,12mo: 2-2-2",
  "30A-32A-34A-36A: 1-2-2-1",
  "30A-32A-34A: 2-2-2",
  "32A-34A-36A: 2-2-2",
  "34B-34C-36B-36C-38C: 1-1-1-2-1",
  "34B-34C-36C-38C: 1-1-2-1",
  "34B/S-34C/M-36B/M-36C/L: 2-2-1-1",
  "34B/S-34C/M-36B/M: 1-1-1",
  "36DD-38D-38DD-40D-40DD-42D: 1-1-1-1-1-1",
  "36DD-38D-38DD: 1-1-1",
  "3T-4T: 1-2",
  "4-4-6-6-8-8-10-10-12-12: 17-15-17-15-16-14-13-15-13-15",
  "4-5-6-6X: 1-2-2-1",
  "4-5-6-7-8: 1-1-2-1-1",
  "4-5-6-7: 1-2-2-1",
  "4-5-6/6X: 1-1-1",
  "4-5/6-6X-7/8: 1-2-2-1",
  "4-5/6-6X-7: 2-2-2-2",
  "4-5/6-6X: 2-2-2",
  "4-5/6-7/8-10/12: 1-2-2-1",
  "4-5/6-7/8-10: 1-2-2-1",
  "4-5/6-7/8: 1-3-2",
  "4-5/6-7/8: 2-2-2",
  "4-5/6-7: 1-3-2",
  "4-5/6-7: 2-2-2",
  "4-6-8-10-12-14-16: 1-1-1-2-1-1-1",
  "4-6-8-10: 2-3-2-1",
  "4-6-8-10: 3-4-3-2",
  "4/5-6/6X-7/8-10/12-14/16: 1-2-2-3-4",
  "4/5-6/6X-7/8-10/12-14/16: 1-2-3-4-2",
  "4/6(S)-8/10(M)-12/14(L)-16/18(XL): 1-2-2-1",
  "5,6,8,10,12,14: 2-2-2-2-1-1",
  "5,6,8,10,12: 2-2-2-1-1",
  "5-6-8-10-12-14: 2-2-2-2-2-2",
  "5/6(S)-7/8(M)-10/12(L): 2-2-2",
  "5/6(S)-7/8(M)-9/10(L): 1-3-2",
  "5/6-7/8-10/12: 1-2-1",
  "5/6-7/8-10/12: 2-2-2",
  "5/6-7/8-10/12: 4-4-4",
  "5/6-7/8-: 2-1",
  "5/6-7/8-: 4-2",
  "6,7,8,9,10,11: 1,3,4,3,1,1",
  "6,7,8,9,10: 1,3,4,3,1",
  "6,8,10,12: 2,2,1,1",
  "6-7-8-9-10-11: 1-1-2-3-3-2",
  "6-7-8-9-10-11: 1-2-2-3-2-2",
  "6-7-8-9-10-11: 1-2-4-3-1-1",
  "6-7-8-9-10: 1-2-1-1-1",
  "6-7-8-9-10: 1-2-2-2-1",
  "6-7-8-9-10: 1-2-3-2-1",
  "6-7-8-9-10: 2-3-3-3-1",
  "6-8-10-12-14: 2-2-2-1-1",
  "6-8-10-12: 1-2-2-1",
  "6-8-10-12: 2-2-2-2",
  "6-9mo,12mo,18mo: 2-2-2",
  "7-8-10-12-14-16: 1-1-1-1-1-1",
  "7-8-10-12-: 1-2-2-1",
  "7-8-10/12-14: 1-2-2-1",
  "7-8-10: 2-2-2",
  "7-8-9-10-11: 1-1-3-2-2",
  "7-8-9-10-11: 1-2-1-1-1",
  "7/8(S)-9/10(M)-11/12(L)-13/14(XL): 1-2-2-1",
  "7/8-10-12: 2-2-2",
  "7/8-10/12-14/16: 2-2-2",
  "7/8-10/12-14/16: 3-2-1",
  "7/8-10/12-14: 1-2-1",
  "7/8-10/12-14: 2-2-2",
  "7/8-10/12: 3-3",
  "7/8-10/12: 4-2",
  "8-10-12-14: 1-2-2-1",
  "8-10-12-14: 2-2-2-2",
  "8-10-12: 2-2-2",
  "8-10/12-14-16: 1-2-2-1",
  "A-B-C-D: 1-2-2-1",
  "A-B-C: 1-3-2",
  "A/B-C/D: 1-2",
  "B-C-D: 2-3-1",
  "M-L-1X-2X: 1-2-2-1",
  "M-L-1XL-2XL: 1-2-2-1",
  "M-L-XL-2X: 1-2-2-1",
  "M-L-XL-2XL: 1-2-2-1",
  "M-L-XL: 1-3-2",
  "M-L-XL: 1-4-3",
  "M-L-XL: 2-2-2",
  "M-L-XL: 2-3-3",
  "M-L-XL: 3-3-1",
  "M-L-XL: 3-4-4",
  "M-L-XL: 4-5-6",
  "M-L: 1-2",
  "PS-PM-PL-PXL: 1-1-2-2",
  "S-M-L-XL-XXL: 1-1-2-1-1",
  "S-M-L-XL-XXL: 1-1-2-2-1",
  "S-M-L-XL-XXL: 1-3-3-3-2",
  "S-M-L-XL-XXL: 2-2-2-1-1",
  "S-M-L-XL-XXL: 2-3-3-2-2",
  "S-M-L-XL-XXL: 2-3-3-3-2",
  "S-M-L-XL-XXL: 2-3-4-3-2",
  "S-M-L-XL: 1-1-1-1",
  "S-M-L-XL: 1-1-2-2",
  "S-M-L-XL: 1-2-3-1",
  "S-M-L-XL: 1-2-3-2",
  "S-M-L-XL: 1-3-2-1",
  "S-M-L-XL: 1-3-3-1",
  "S-M-L-XL: 2-2-1-1",
  "S-M-L-XL: 2-2-2-2",
  "S-M-L-XL: 2-2-3-1",
  "S-M-L-XL: 2-3-2-1",
  "S-M-L-XL: 2-3-3-2",
  "S-M-L-XL: 2-4-4-2",
  "S-M-L-XL: 2-4-4-3",
  "S-M-L-XL: 2-4-5-3",
  "S-M-L-XL: 2-5-5-2",
  "S-M-L-XL: 3-5-5-3",
  "S-M-L-XL: 3-6-6-3",
  "S-M-L-XL: 4-6-4-2",
  "S-M-L-XL: 7-8-5-4",
  "S-M-L: 1-1-1",
  "S-M-L: 1-2-1",
  "S-M-L: 1-2-2",
  "S-M-L: 2-2-2",
  "S-M-L: 2-3-1",
  "S-M-L: 3-2-1",
  "S/M-L/XL: 1-2",
  "S/M-L/XL: 2-1",
  "S/M-L/XL: 2-2",
  "S/M-L/XL: 3-3",
  "S/M-L/XL: 4-2",
  "S/M-M/L-L/XL-XL/2XL: 1-2-2-1",
  "S/M-M/L-L/XL: 1-1-1",
  "S/M-M/L-L/XL: 2-2-2",
  "S/M-M/L: 3-3",
  "XS-S-M-L-XL-XXL: 1-1-1-1-1-1",
  "XS-S-M-L-XL-XXL: 1-2-3-2-1-1",
  "XS-S-M-L-XL-XXL: 1-3-5-5-4-2",
  "XS-S-M-L-XL: 1-1-1-1-1",
  "XS-S-M-L-XL: 1-1-2-1-1",
  "XS-S-M-L-XL: 1-1-2-2-1",
  "XS-S-M-L-XL: 1-1-3-2-1",
  "XS-S-M-L-XL: 1-2-1-1-1",
  "XS-S-M-L-XL: 1-2-2-1-1",
  "XS-S-M-L-XL: 1-2-2-2-1",
  "XS-S-M-L-XL: 1-2-3-3-2",
  "XS-S-M-L-XL: 1-2-4-3-1",
  "XS-S-M-L: 1-1-1-1",
  "XS-S-M-L: 1-2-2-1",
  "XS-S-M: 1-2-1",
  "XS/S-M/L: 3-3",
  "XS-S-M-L: 2-2-1-1",
  "5/6(S)-6.5/7.5(M)-8/9(L): 1-2-3",
  "34B-34C-36B-36C-38C: 2-1-1-1-1",
  "36D-38D-38DD-40C-40D-42D: 1-1-1-1-1-1",
  "34B-34C-36B-36C-36DD-38C: 1-1-1-1-1-1",
  "11-12-13-1-2-3: 1-1-1-1-1-1",
  "5/6(S)-6.5/7.5(M)-8/9(L): 2-2-2",
  "XS-S-M: 1-2-3",
  "0/3M-3/6M-6/9M-9/12M: 2-2-2-2",
  "3T-4T: 3-3",
  "0/3M-3/6M-6/9M-9/12M: 1-2-2-1",
  "S-M-L-XL-XXL: 1-2-3-3-2",
  "S-M-L-XL-XXL: 1-3-4-3-2",
  "S-M-L-XL-XXL: 1-2-3-2-1",
  "5/6-7/8-10/12-14: 1-2-2-1",
  "S-M-L-XL-XXL: 1-2-3-2-2",
  "3T-4T: 1-1",
  "4-5/6-7: 1-1-1",
  "5/6-7/8-10/12: 1-1-1",
  "S-M-L-XL-XXL: 4-4-4-3-2",
  "S-M-L-XL-XXL: 4-4-3-3-2",
  "S-M-L-XL-XXL: 3-4-4-2-2",
  "1X-2X: 3-3",
  "XS-S-M: 2-2-2",
  "8-10: 2-2",
  "S-M-L-XL: 4-5-5-4",
  "S-M-L-XL: 3-4-2-3",
  "0/3M-3/6M-6/9M-9/12M: 1-2-1-1",
  "3T-4T: 2-2",
  "M-L-XL: 1-1-1",
  "12M-18M-24M: 1-1-1",
  "S-M-L-XL: 3-5-5-5",
  "M-L-XL: 2-3-1",
  "S-M: 3-3",
  "1X-2X: 1-2",
  "10-11-12-13-1-2: 1-1-1-1-1-1",
  "M-L-XL: 2-3-1",
  "7/8-8/10-10/12: 2-2-2",
  "30A-32A-34A-36A: 1-3-3-1",
  "30A-32A-34A-36A: 1-2-3-2",
  "34B-34C-36B-36C-38B-38C: 1-1-1-1-1-1",
  "2/3T-4T-5T: 2-3-3",
  "XS-S-M-L-XL: 1-2-2-2-1",
  "XS-S-M-L: 2-3-2-1",
  "34B-34C-34D-36B-36C-36D: 1-1-1-1-1-1",
  "34B/S-34C/M-36B/M-36C/L: 2-2-1-1",
  "34B-34C-36B-36C-38C-34DD: 1-1-1-1-1-1",
  "4-5-6-7: 1-1-1-1",
  "8-10-12-14: 1-1-1-1",
  "7/8-10/12: 2-1",
  "4-/5/6-6X: 1-1-1",
  "32D-34D-36D-32DD-34DD-36DD: 1-1-1-1-1-1",
  "30A-32A-34A-36A: 2-2-2-2",
  "10/12-14/16: 3-3",
  "32A-34B-34C-36B-36C-38B: 1-1-1-1-1-1"
]

let seasonList = [
  "BACK TO SCHOOL 18",
  "BACK TO SCHOOL 19",
  "BACK TO SCHOOL 20",
  "BACK TO SCHOOL 25",
  "BASICS",
  "CHRISTMAS",
  "EASTER",
  "FALL",
  "HALLOWEEN",
  "HANUKKAH",
  "HOLIDAY",
  "HOLIDAY 25",
  "N/A",
  "PRIDE",
  "Q1 2021",
  "Q1 2022",
  "Q1 2025",
  "Q2 2021",
  "Q2 2022",
  "Q2 2025",
  "Q3 2021",
  "Q3 2025",
  "Q4 2020",
  "Q4 2021",
  "Q4 2025",
  "SPRING",
  "SPRING/SUMMER",
  "SS19",
  "SS20",
  "SS25",
  "ST. PATRICK’S DAY",
  "SUMMER",
  "TBD",
  "VALENTINE",
  "WINTER"
]


const unminifyAccountName = (accountName) => {
  if ('number' == typeof accountName) {
    return accountList[accountName]
  } else {
    return accountName
  }
}

const unminifyRep = (rep) => {
  if ('number' == typeof rep) {
    return repList[rep]
  } else {
    return rep
  }
}

const unminifySeason = (season) => {
  if ('number' == typeof season) {
    return seasonList[season]
  } else {
    return season
  }
}

const unminifyBrand = (brand) => {
  if ('number' == typeof brand) {
    return brandList[brand]
  } else {
    return brand
  }
}

const unminifyDivision = (division) => {
  if ('number' == typeof division) {
    return divisionList[division]
  } else {
    return division
  }
}

const unminifySubcategory = (subcategory) => {
  if ('number' == typeof subcategory) {
    return subcategoriesList[subcategory]
  } else {
    return subcategory
  }
}

const unminifyCategory = (category) => {
  if ('number' == typeof category) {
    return categoriesList[category]
  } else {
    return category
  }
}

const unminifySub2 = (sub2) => {
  if ('number' == typeof sub2) {
    return sub2List[sub2]
  } else {
    return sub2
  }
}

const unminifyFabrication = (fabrication) => {
  if ('number' == typeof fabrication) {
    return fabricationsList[fabrication]
  } else {
    return fabrication
  }
}

const unminifyColor = (color) => {
  if ('number' == typeof color) {
    return colorList[color]
  } else {
    return color
  }
}

const unminifyPacks = (packs) => {
  if ('number' == typeof packs) {
    return packsList[packs]
  } else {
    return packs
  }
}

const unminifySizes = (sizes) => {
  if ('number' == typeof sizes) {
    return singleSizesList.concat(sizesList)[sizes]
  } else {
    return sizes
  }
}

let quantity = (shipped_order) => {
  return shipped_order.quantity == null ? shipped_order.q : shipped_order.quantity
}

let _ponumber = (shipped_order) => {
  return shipped_order.ponumber == null ? shipped_order.p : shipped_order.ponumber
}

let date = (shipped_order) => {
  return shipped_order.date == null ? shipped_order.d : shipped_order.date
}

let salesPrice = (shipped_order) => {
  return shipped_order.sales_price == null ? shipped_order.s : shipped_order.sales_price
}

let accountName = (shipped_order) => {
  return shipped_order.account_name == null ? unminifyAccountName(shipped_order.a) : shipped_order.account_name
}

let _rep = (shipped_order) => {
  let result = shipped_order.rep == null ? unminifyRep(shipped_order.r) : shipped_order.rep
  if (result == null) {
    return null
  } else  {
    return result.replace('_sales','')
  }
}

let _atsRep = (rep) => {
  if (rep == null) {
    return null
  } else  {
    return unminifyRep(rep).replace('_sales','').replace('@ihlgroup.com','')
  }
}

//the rep on an order, in the same short form the Rep dropdown uses (see repOptions in cads2/options.js)
let _repName = (order) => {
  let result = _rep(order)
  return result == null ? null : result.replace('@ihlgroup.com','')
}

let _atsRepCard = (rep) => {
  if (rep == null) {
    return null
  } else  {
    return '(rep: '+unminifyRep(rep).replace('_sales','').replace('@ihlgroup.com','')+')'
  }
}

export {quantity, _ponumber, date, salesPrice, accountName, _rep, _repName, unminifyBrand, unminifyDivision, unminifyCategory, unminifyFabrication, fabricationsList, unminifySubcategory, unminifySub2, unminifyColor, unminifyPacks, unminifyAccountName, singleSizesList, sizesList, unminifySizes, unminifySeason, seasonList, _atsRep, _atsRepCard, repList}
